module.exports = __webpack_public_path__ + "static/img/button2.777899a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/bodyfriend/button2.png
// module id = TZMw
// module chunks = 1